module.exports = __webpack_public_path__ + "static/img/fish33.90f23da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish33.png
// module id = w504
// module chunks = 0